module.exports = __webpack_public_path__ + "static/media/Group3635.08a6c043.svg";